import { AppBar, Box, Toolbar } from '@mui/material'
import PropTypes from 'prop-types'
import styles from './adminNavbarStyle'

export default function AdminNavbar(props) {
  const { color, brandText } = props

  return (
    <AppBar sx={[styles.appBar, color && styles[color]]}>
      <Toolbar sx={styles.container} variant="dense">
        <Box component={'div'} sx={styles.flex}>
          <Box component={'h5'} sx={styles.title}>
            {brandText}
          </Box>
        </Box>
      </Toolbar>
    </AppBar>
  )
}

AdminNavbar.propTypes = {
  color: PropTypes.oneOf(['primary', 'info', 'success', 'warning', 'danger']),
  rtlActive: PropTypes.bool,
  brandText: PropTypes.string,
  miniActive: PropTypes.bool,
  handleDrawerToggle: PropTypes.func,
  sidebarMinimize: PropTypes.func,
}
